module.exports = __webpack_public_path__ + "img/31121-2-283x400.9777a585.jpg";